import React, {useEffect} from "react";
import { Link } from "react-router-dom";
import Breadcrumb from "../Components/Breadcrumb";
import bgImg from '../Images/contact-breadcrumb.webp'
import { motion } from "framer-motion";
import { GandhidhamProducts, additionalProductGandhidham } from "../Data";
import Cta from "../Components/Cta";
import SchemaMarkup from "../Components/SchemaMarkup";
import WebPageSchema from "../Schema/webPageSchema";
import createBreadcrumbSchema from "../Schema/breadcrumbSchema";
import ProductComparisonTable from "../Components/ProductComparisonTable";

const ProductsCommonGandhidham=()=>{
    const allProducts = [...GandhidhamProducts, ...additionalProductGandhidham];

useEffect(() => {
        document.title =
          "Wooden Packaging Products in Gandhidham | Gurukrupa Wood Pvt. Ltd.";
    
        const metaDesc = document.querySelector("meta[name='description']");
        if (metaDesc) {
          metaDesc.setAttribute(
            "content",
            "Explore durable wooden packaging products in Gandhidham, including pallets, boxes, crates and customised packaging for industrial and export needs."
          );
        }
    
        const canonical = document.querySelector("link[rel='canonical']");
      if (canonical) {
        canonical.setAttribute("href", "https://gurukrupawood.com/products/gandhidham");
      }
    
      const ogTitle = document.querySelector("meta[property='og:title']");
      if (ogTitle) {
        ogTitle.setAttribute(
          "content",
          "Wooden Packaging Products in Gandhidham | Gurukrupa Wood Pvt. Ltd."
        );
      }
    
        const ogDesc = document.querySelector("meta[property='og:description']");
      if (ogDesc) {
        ogDesc.setAttribute(
          "content",
          "Explore durable wooden packaging products in Gandhidham, including pallets, boxes, crates and customised packaging for industrial and export needs."
        );
      }
    
      const ogUrl = document.querySelector("meta[property='og:url']");
      if (ogUrl) {
        ogUrl.setAttribute("content", "https://gurukrupawood.com/products/gandhidham");
      }
    
        const ogImage = document.querySelector("meta[property='og:image']");
      if (ogImage) {
        ogImage.setAttribute(
          "content",
          "https://gurukrupawood.com/about.webp"
        );
      }
    
        const twitterTitle = document.querySelector("meta[name='twitter:title']");
      if (twitterTitle) {
        twitterTitle.setAttribute(
          "content",
          "Wooden Packaging Products in Gandhidham | Gurukrupa Wood Pvt. Ltd."
        );
      }
    
        const twitterDesc = document.querySelector(
        "meta[name='twitter:description']"
      );
      if (twitterDesc) {
        twitterDesc.setAttribute(
          "content",
          "Explore durable wooden packaging products in Gandhidham, including pallets, boxes, crates and customised packaging for industrial and export needs."
        );
      }
    
        const twitterImage = document.querySelector("meta[name='twitter:image']");
      if (twitterImage) {
        twitterImage.setAttribute(
          "content",
          "https://gurukrupawood.com/about.webp"
        );
      }
      }, []);

const schema = WebPageSchema({
    name: "Products of Gurukrupa Wood Pvt. Ltd. in Gandhidham",
    url: "https://gurukrupawood.com/products/gandhidham",
    description:
      "We manufacture wooden pallets, Euro pallets, wooden boxes, plywood boxes, crates and customised packaging for industrial and export applications."
  });

const breadcrumbSchema = createBreadcrumbSchema([
  {
    name: "Home",
    url: "https://gurukrupawood.com/"
  },
  {
    name: "Products in Gandhidham",
    url: "https://gurukrupawood.com/products/gandhidham"
  },
]);
    return(
        <>
 <SchemaMarkup data={schema} />
      <SchemaMarkup data={breadcrumbSchema} />
        
           <Breadcrumb
  pageName="Our Wooden Packaging Products in Gandhidham"
  bgImage={bgImg}
/>

  {/**PRODUCTS GRID */}
    <section className="products-section container product-pg">

  {/* TOP */}
  <motion.div
    className="products-top"
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1],
    }}
    viewport={{ once: true, amount: 0.3 }}
  >

    <div className="products-heading">

      <motion.h3
        className="section-subheading"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1, duration: 0.5 }}
        viewport={{ once: true }}
      >
        OUR PRODUCTS
      </motion.h3>

      <motion.h2
        className="section-heading"
        initial={{ opacity: 0, y: 35 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.7 }}
        viewport={{ once: true }}
      >
        Strong. Durable. Reliable.<br /> Built for Gandhidham Industries.
      </motion.h2>

    </div>

  </motion.div>

  {/* PRODUCTS GRID */}
  <motion.div
    className="products-grid"
    variants={{
      hidden: {},
      visible: {
        transition: {
          staggerChildren: 0.16,
        },
      },
    }}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.15 }}
  >

    {allProducts.map((item, i) => (
      <motion.div
        className="products-card"
        key={i}
        variants={{
          hidden: {
            opacity: 0,
            y: 60,
          },
          visible: {
            opacity: 1,
            y: 0,
          },
        }}
        transition={{
          duration: 0.75,
          ease: [0.22, 1, 0.36, 1],
        }}
        whileHover={{
          y: -10,
        }}
      >
        <Link to={`/products/${item.slug}`}>
        {/* IMAGE ZOOM */}
        <motion.div
          style={{ overflow: "hidden" }}
        >
          <motion.img
            src={item.img}
            alt={`${item.title} | Gurukrupa Wood Pvt. Ltd.`}
            whileHover={{
              scale: 1.08,
            }}
            transition={{ duration: 0.5 }}
          />
        </motion.div>

        {/* CONTENT */}
        <motion.div
          className="product-card"
          initial={{ opacity: 0.9 }}
          whileHover={{
            opacity: 1,
          }}
        >

          <h4 className="card-heading">{item.title}</h4>

          <p className="section-text">{item.desc}</p>

         <motion.a
  href={`/products/${item.slug}`}
  className="product-card-link"
  whileHover="hover"
  initial="rest"
>

  <motion.span
    className="know-more-text"
    variants={{
      rest: {
        opacity: 0,
        width: 0,
        marginRight: 0,
      },
      hover: {
        opacity: 1,
        width: "auto",
        marginRight: 4,
      },
    }}
    transition={{
      duration: 0.3,
    }}
  >
    Know More
  </motion.span>

  <motion.span
    className="arrow-icon"
    variants={{
      rest: {
        x: 0,
      },
      hover: {
        x: 8,
      },
    }}
    transition={{
      duration: 0.3,
    }}
  >
    →
  </motion.span>

</motion.a>

        </motion.div>
</Link>
      </motion.div>
    ))}

  </motion.div>

</section>

{/**TABLE SECTION */}

<ProductComparisonTable />

{/**CTA */}
<Cta 
heading="Precision Packaging for Every Industrial Application in Gandhidham"
desc="We are here to provide the best packaging solutions in Gandhidham tailored to your needs."
slug="/products/customised-packaging-solution-in-gandhidham"
/>      
        </>
    )
}
export default ProductsCommonGandhidham;